// @flow
/** @jsx jsx */

import List from '@zapier/common-components/src/components/List';
import Text from '@zapier/common-components/src/components/Text';
import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';

import FaqQuestion, { type FaqQuestionType } from './FaqQuestion';

type Props = {
  /** FAQ's */
  questions: Array<FaqQuestionType>,
  /** Default open FAQ */
  target?: FaqQuestionType,
  /** Section Title */
  title?: string,
  /** Use horizontal padding inside of question */
  useHorizontalPadding?: boolean,
};

const faqCss = {
  padding: '50px 0',
};

const titleCss = {
  color: Colors.deepspace,
  marginBottom: '14px',
  textAlign: 'center',
};

const getKey = (faq: FaqQuestionType, i: number) => faq.id || i;

const Faq = ({
  questions,
  target,
  title,
  useHorizontalPadding = false,
}: Props) => {
  return (
    <div css={faqCss}>
      {title && (
        <div css={titleCss}>
          <Text type="main-head-strong">{title}</Text>
        </div>
      )}
      <List
        getKey={getKey}
        itemRenderer={(faq: FaqQuestionType) => (
          <FaqQuestion
            isTarget={target === faq}
            useHorizontalPadding={useHorizontalPadding}
            {...faq}
          />
        )}
        items={questions}
      />
    </div>
  );
};

export default Faq;
